import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import type { ICreateReferenceItemsRequest, ICreateReferenceItemsResponse, IReferenceItem } from './types';

export const addItemsToMenu = async (
  menuId: string,
  requestBody: ICreateReferenceItemsRequest[],
): Promise<IReferenceItem[]> => {
  try {
    const url = `${API_URL}/menus/${menuId}/items`;

    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to create reference items in menu');
    }

    const { data }: ICreateReferenceItemsResponse = await response.json();
    return data;
  } catch (e) {
    console.error('Error while adding a product to the menu:', e);
    if (e instanceof Error) {
      throw e;
    }
    throw new Error('Something went wrong whilst adding a product to the menu');
  }
};
